import { render, staticRenderFns } from "./InfoCardStat.vue?vue&type=template&id=b6e8b0a4"
import script from "./InfoCardStat.js?vue&type=script&lang=js&external"
export * from "./InfoCardStat.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports